export default "__VITE_ASSET__Dw_VJ198__"